/* eslint-disable import/prefer-default-export */

export const isJustPlus = (fits) =>
  Array.isArray(fits) &&
  fits.length === 1 &&
  fits[0]?.name === "Plus" &&
  fits[0]?.available === true;

export const isBottom = (productType) => {
  const currentType = JSON.parse(productType);
  const types = currentType.map(item => item.toLowerCase());
  const hasBottoms = types.includes("bottoms") || types.includes("pantalons et plus");
  const hasNoSkirts = !types.includes("skirts") || types.includes("jupes");
  if (hasBottoms && hasNoSkirts) {
    return true
  }
  return false;
}

export const setBadges = (productType, fits, badges, inseam) => {
  const productBadges = [];

  // Add inseam badge first (above sizes)
  if (isBottom(productType) && inseam) {
    const inputInseam = inseam.replace(/'/g, '"');
    const [inseamValue] = JSON.parse(inputInseam);

    // eslint-disable-next-line max-len
    const locale = window.localization?.language?.iso_code || window.locale || null;
    const isFrench = locale && locale.toLowerCase().startsWith('fr');

    const formattedInseam = isFrench
      ? inseamValue.replace(/"/g, ' po')
      : inseamValue;

    productBadges.push(formattedInseam);
  }

  // Then add size badge
  if (badges) {
    let currentBadges = JSON.parse(badges);
    currentBadges = currentBadges.map((tag) => tag.toLowerCase().trim());

    const sizeBadge = window.TMW.badgesLaura.find((badge) =>
      currentBadges.includes(badge.toLowerCase())
    );

    if (sizeBadge) {
      productBadges.push(sizeBadge);
    }
  }

  return productBadges;
};/* eslint-disable import/prefer-default-export */

export const shouldShowInseam = (productTypeValue) => {
  if (!productTypeValue) return false;

  try {
    // const types = JSON.parse(productTypeValue).map((item) => item.toLowerCase());

    const parsedProductType = JSON.parse(productTypeValue);
    const types = parsedProductType.map((item) => item.toLowerCase());

    const hasBottoms =
      types.includes('bottoms') || types.includes('pantalons et plus');
    const hasSkirts = types.includes('skirts') || types.includes('jupes');

    return hasBottoms && !hasSkirts;
  } catch (error) {
    // Silent fail and return false when parsing fails
    return false;
  }
};

export const getInseamValue = (productTypeValue, inseam) => {
  if (!productTypeValue || !inseam) return null;

  if (!shouldShowInseam(productTypeValue)) return null;

  try {
    const cleanedInseam = inseam.replace(/'/g, '"');
    const [firstInseam] = JSON.parse(cleanedInseam);

    // Remove the double quote if it exists
    return firstInseam.replace(/"/g, '');
  } catch (error) {
    // Silent fail and return null when parsing fails
    return null;
  }
};
